const Loading = () => {
  return (
    <div id="loading" className="loading-spinner d-flex flex-column align-items-center justify-content-center">
      <div className="progress-bar"></div>
    </div>
  );
};

export default Loading;
